import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthLinkModule } from '@shared/core/modules/auth/components/authLink';
import { ButtonsModule } from '@shared/core/components/buttons';
import { LinkModule } from '@shared/core/components/link';
import { CartButtonModule } from '@shared/core/modules/cart/components/cartButton';
import { CartLocationButtonModule } from '@shared/core/modules/cart/components/cartLocationButton';
import { CollectionTypeToggleModule } from '@shared/core/components/collectionTypeToggle';

import { NavBarUcpComponent } from './nav-bar-ucp.shared.component';

@NgModule({
    declarations: [
        NavBarUcpComponent,
    ],
    imports: [
        CommonModule,
        AuthLinkModule,
        ButtonsModule,
        LinkModule,
        CartButtonModule,
        CartLocationButtonModule,
        CollectionTypeToggleModule,
    ],
    exports: [
        NavBarUcpComponent,
    ],
})
export class NavBarUcpModule { }
